import $ from 'jquery';
import 'modernizr';
import objectFitImages from 'object-fit-images';
import SmoothScroll from './SmoothScroll';
import Features from './features';

window.submitNewsletterForm = function () {
    let $newsletterForm = $('#newsletter-form');

    $.post({
        url: window.Zeste.adminUrl,
        data: $newsletterForm.serialize(),
        dataType: 'text',
        statusCode: {
            400: function (jqXHR) {
                var response = $.parseJSON(jqXHR.responseText);
                if (response.errors.email.length) {
                    $('.home section.row.newsletter .form form input[type="email"]').css('border-bottom-color', '#fd8282');
                }
            }
        }
    }).done(function () {
        $newsletterForm[0].reset();
        $('.home section.row.newsletter .form h3').html('Félicitations !');
        $('.home section.row.newsletter .form .title').html('Vous vous êtes inscrit à la newsletter Zeste !');
        $('.home section.row.newsletter .form form').css('opacity', '0');
        $('.newsletter .video video')[0].play();
    }).always(function () {
        grecaptcha.reset();
    });
};

$(() => {

    objectFitImages();

    SmoothScroll({
        stepSize: 150,
        animationTime: 550,
        keyboardSupport: true,
        arrowScroll: 150
    });

    const feature = new Features();

    feature.init();
    feature.barba();

    /*
    * Animation de l'image sur le hover d'un article sur la page categories
    */
    $(document).on('mouseenter', '.category .content .category-content article', function () {
        $('#section-images a').removeClass('active');

        $('#section-images a').eq($(this).index()).addClass('active').parent().css('background', $(this).find('> a').data('color'));

        $('nav #search-btn svg, nav #tag-btn svg').css('stroke', $(this).find('> a').data('color'));
        $('footer .rs a').css('background', $(this).find('> a').data('color'));
        $('aside#pagination div').css('border-color', $(this).find('> a').data('color')).find('span').css('color', $(this).find('> a').data('color'));
    });

    /*
    * Affichage de tous les commentaires sur la page article
    */
    $(document).on('click', 'section #comments .comments .more', function () {
        var elt = $(this);
        $('html, body').animate({
            scrollTop: $('section #comments form').offset().top - 40
        }, 300).promise().then(function () {
            $('section #comments form').addClass('open');
            $('section #comments form #author').focus();

            var getParent = elt.parent().attr('id').split('-')[1];
            $('section #comments form #comment_parent').attr('value', getParent);
        });
    });

    /*
    *   affichage formulaire commentaire sur page single
    */
    $(document).on('click', 'section #comments form', function () {
        $(this).addClass('open');
    });

    /*
    * Scroll au clic sur la pagination d'un article
    */
    $(document).on('click', 'section #pagination > div', function () {
        var getIndex = $(this).index();

        $('html, body').animate({
            scrollTop: ($('main section article.col-1').eq(getIndex).offset().top + 1) + 'px'
        }, 1500);
    });

    /*
    * Scroll au clic sur la pagination d'un article
    */
    $(document).on('click', 'main > #pagination > div', function () {
        var getIndex = $(this).index();

        if (getIndex == 0) {
            $('html, body').animate({
                scrollTop: 0
            }, 1500);
        } else {
            $('html, body').animate({
                scrollTop: ($('main section').eq(getIndex).offset().top + 1) + 'px'
            }, 1500);
        }
    });

    /*
    * Evenements au scroll
    */
    $(document).scroll(function () {
        var currentScroll = $(document).scrollTop();

        /*
        * Fixe de la section Tous les articles si partie de droite plus grande que la hauteur de la fenetre
        */
        if ($('body').hasClass('home')) {
            if ($('.latest').offset().top < currentScroll) {
                if (!$('.latest .latest-image').hasClass('fixed')) {
                    $('.latest .latest-image').addClass('fixed');
                }
            } else {
                $('.latest .latest-image').removeClass('fixed');
            }

            if (($('.latest').offset().top + $('.latest').outerHeight()) < (currentScroll + $(window).height())) {
                if ($('.latest .latest-image').hasClass('fixed')) {
                    $('.latest .latest-image').addClass('past');
                    $('.latest .latest-image').removeClass('fixed');
                }
            } else {
                if ($('.latest .latest-image').hasClass('past')) {
                    $('.latest .latest-image').removeClass('past');
                    $('.latest .latest-image').addClass('fixed');
                }
            }

            $('main > section').each(function () {
                var element = $(this);

                if (element.offset().top < currentScroll && !element.hasClass('previous')) {
                    element.addClass('previous');
                    $('#pagination > div').removeClass('active').eq(element.index() - 1).addClass('active');
                }

                if (element.offset().top + 2 > currentScroll && element.hasClass('previous')) {
                    element.removeClass('previous');
                    $('#pagination > div').removeClass('active').eq(element.index() - 1).addClass('active');
                }

                if (currentScroll == ($(document).height() - $(window).height())) {
                    $('#pagination > div').removeClass('active').eq($('main > section.newsletter').index() - 1).addClass('active');
                }
            });
        }

        /*
        *   Affichage image et pagination en fonction article visible
        */
        if ($('body').hasClass('single')) {
            $('main > section > article').each(function () {
                var elt = $(this);

                if (elt.offset().top < currentScroll && !elt.hasClass('previous')) {
                    elt.addClass('previous');
                    $('#section-images img').eq(elt.data('article')).css('transform', 'translateY(0%)').prev().css('transform', 'translateY(-50%)');
                    $('section #pagination > div').removeClass('active').eq(elt.index() - 1).addClass('active');
                }

                if (elt.offset().top + 2 > currentScroll && elt.hasClass('previous')) {
                    elt.removeClass('previous');
                    $('#section-images img').eq(elt.data('article')).css('transform', 'translateY(calc(100% + 50px))').prev().css('transform', 'translateY(0%)');
                    $('section #pagination > div').removeClass('active').eq(elt.index() - 1).addClass('active');
                }
            });
        }

        if ($('body').hasClass('page-template-gabarit-job')) {
            $('main > section > article').each(function () {
                var elt = $(this);

                if (elt.offset().top < currentScroll && !elt.hasClass('previous')) {
                    elt.addClass('previous');
                    $('section #pagination > div').removeClass('active').eq(elt.index() - 1).addClass('active');
                }

                if (elt.offset().top + 2 > currentScroll && elt.hasClass('previous')) {
                    elt.removeClass('previous');
                    $('section #pagination > div').removeClass('active').eq(elt.index() - 1).addClass('active');
                }
            });
        }
    });

});